import Footer from '@/components/Layouts/Footer'
import Header from '@/components/Layouts/Header'
import React from 'react'
import Head from 'next/head'
import Link from 'next/link'

const TermsOfServices = () => {
    return (
        <>
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
                <title>Terms and Conditions - Smart Card Generator</title>
                <meta property="og:type" content="website" />
                <meta
                    property="og:url"
                    content="https://smartcardgenerator.net/terms-of-services"
                />
                <meta
                    property="description"
                    content="Welcome to Smart Card Generator! This Agreement is a contract between you and Women In Digital, a.k.a Smart Card Generator. A Smart Card Generator is an online tool that enables users to create digital smart visiting cards, business cards, Social media cards, etc. It provides a convenient way to generate personalized digital cards with essential information, including a QR code for quick access."
                />
                <meta
                    property="og:description"
                    content="Welcome to Smart Card Generator! This Agreement is a contract between you and Women In Digital, a.k.a Smart Card Generator. A Smart Card Generator is an online tool that enables users to create digital smart visiting cards, business cards, Social media cards, etc. It provides a convenient way to generate personalized digital cards with essential information, including a QR code for quick access."
                />
                <meta property="og:type" content="Description" />
                <meta
                    property="og:title"
                    content="Terms and Conditions - Smart Card Generator"
                />
                <meta property="og:image" content="/img/meta_image/terms.jpg" />
                <meta property="image" content="/img/meta_image/terms.jpg" />
                <meta property="og:site_name" content="Smart Card Generator" />
            </Head>
            <Header />

            <div className="faq-question-wrapper">
                <div className="faq-img">
                    <img src="/img/home/terms-banner.svg" alt="" />
                </div>
                <div className="container">
                    <div className="row d-flex align-items-center justify-content-center">
                        <div className=" col-md-10">
                            <div className=" faq-content-wrapper">
                                <h1 className="text-center">
                                    Smart Card Generator operating since 2024
                                </h1>
                                <div className="faq-content-item">
                                    <h2>
                                        Our Terms and Conditions were last
                                        updated on February 4, 2024.
                                    </h2>
                                    <p>
                                        Welcome to Smart Card Generator! This
                                        Agreement is a contract between you and
                                        Women In Digital, a.k.a Smart Card
                                        Generator. A Smart Card Generator is an
                                        online tool that enables users to create
                                        digital smart visiting cards, business
                                        cards, Social media cards, etc. It
                                        provides a convenient way to generate
                                        personalized digital cards with
                                        essential information, including a QR
                                        code for quick access.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>Acknowledgment</h2>
                                    <p>
                                        These are the Terms and Conditions
                                        governing this Service's use and the
                                        agreement between You and the Company.
                                        These Terms and Conditions set out the
                                        rights and obligations of all users
                                        regarding using the Service. Your access
                                        to and use of the Service is conditioned
                                        on Your acceptance of and compliance
                                        with these Terms and Conditions. These
                                        Terms and Conditions apply to all
                                        visitors, users, and others who access
                                        or use the Service. By accessing or
                                        using the Service, You agree to be bound
                                        by these Terms and Conditions. If You
                                        disagree with any part of these Terms
                                        and Conditions, you may not access the
                                        Service.
                                    </p>
                                    <br />
                                    <p>
                                        Your access to and use of the Service is
                                        also conditioned on Your acceptance of
                                        and compliance with the Company's
                                        Privacy Policy. Our Privacy Policy
                                        describes Our policies and procedures on
                                        the collection, use, and disclosure of
                                        Your personal information when You use
                                        the Application or the Website and tells
                                        You about Your privacy rights and how
                                        the law protects You. Please read Our
                                        Privacy Policy carefully before using
                                        Our Service.
                                    </p>
                                    <br />
                                    <p>
                                        THIS AGREEMENT AND OTHER POLICIES OF
                                        Smart Card Generator MAY BE AMENDED AT
                                        ANY TIME BY POSTING A REVISED VERSION ON
                                        OUR WEBSITE. THE REVISED VERSION WILL BE
                                        EFFECTIVE AT THE TIME WE POST IT.
                                    </p>
                                    <br />
                                    <p>
                                        By using the Smart Card Generator, you
                                        agree to comply with the following terms
                                        and conditions. Please read them
                                        carefully before accessing or using the
                                        application.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2> 1. Acceptance of Terms:</h2>
                                    <p>
                                        By accessing or using the application,
                                        you agree to be bound by these terms and
                                        conditions. You may not use the
                                        application if you do not agree with any
                                        part of these terms.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2> 2. Use of the Application:</h2>
                                    <p>
                                        You may use the application to generate
                                        QR codes for personal and commercial
                                        purposes, provided such usage complies
                                        with these terms and all applicable laws
                                        and regulations.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>3. User Content:</h2>
                                    <p>
                                        The application allows you to input
                                        various types of information to generate
                                        QR codes. The Company is not responsible
                                        for the content of the Service's users.
                                        You expressly understand and agree that
                                        You are solely responsible for the
                                        Content and all activity under your
                                        account, whether by You or any third
                                        person using Your account. You may not
                                        transmit any Content that is unlawful,
                                        offensive, upsetting, intended to
                                        disgust, threatening, libelous,
                                        defamatory, obscene, or otherwise
                                        objectionable. Examples of such
                                        objectionable Content include, but are
                                        not limited to the following:
                                    </p>
                                    <ul>
                                        <li>
                                            Unlawful or promoting unlawful
                                            activity.
                                        </li>
                                        <li>
                                            Defamatory, discriminatory, or
                                            mean-spirited content, including
                                            references or commentary about
                                            religion, race, sexual orientation,
                                            gender, national/ethnic origin, or
                                            other targeted groups.
                                        </li>
                                        <li>
                                            Spam, machine – or
                                            randomly–generated, constituting
                                            unauthorized or unsolicited
                                            advertising, chain letters, any
                                            other form of unauthorized
                                            solicitation, or any form of lottery
                                            or gambling.
                                        </li>
                                        <li>
                                            Containing or installing any
                                            viruses, worms, malware, trojan
                                            horses, or other content that is
                                            designed or intended to disrupt,
                                            damage, or limit the functioning of
                                            any software, hardware, or
                                            telecommunications equipment or to
                                            damage or obtain unauthorized access
                                            to any data or other information of
                                            a third person.
                                        </li>
                                        <li>
                                            Infringing on any party's
                                            proprietary rights, including
                                            patent, trademark, trade secret,
                                            copyright, right of publicity, or
                                            other rights.
                                        </li>
                                        <li>
                                            Impersonating any person or entity,
                                            including the Company and its
                                            employees or representatives.
                                        </li>
                                        <li>
                                            Violating the privacy of any third
                                            person.
                                        </li>
                                        <li>False information and features.</li>
                                        <li>
                                            Infringing on any party's
                                            proprietary rights, including
                                            patent, trademark, trade secret,
                                            copyright, right of publicity, or
                                            other rights.
                                        </li>
                                    </ul>
                                    <br />
                                    <p>
                                        The Company reserves the right, but not
                                        the obligation, to, in its sole
                                        discretion, determine whether or not any
                                        Content is appropriate and complies with
                                        these Terms, refuse or remove this
                                        Content. The Company further reserves
                                        the right to make formatting and edits
                                        and change the manner of any Content.
                                        The Company can also limit or revoke the
                                        use of the Service if You post such
                                        objectionable Content. As the Company
                                        cannot control all content posted by
                                        users and/or third parties on the
                                        Service, you agree to use the Service at
                                        your own risk. You understand that by
                                        using the Service, You may be exposed to
                                        content that You may find offensive,
                                        indecent, incorrect, or objectionable.
                                        You agree that under no circumstances
                                        will the Company be liable in any way
                                        for any content, including any errors or
                                        omissions in any content, or any loss or
                                        damage of any kind incurred as a result
                                        of your use of any content.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2> 4. Intellectual Property:</h2>
                                    <p>
                                        The application and its content,
                                        including but not limited to text,
                                        graphics, logos, and QR codes generated,
                                        are the property of the application's
                                        developer.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>5. Privacy Policy:</h2>
                                    <p>
                                        The application may collect and store
                                        certain user information, as the Privacy
                                        Policy outlines. By using the
                                        application, you consent to collecting
                                        and using your information as described
                                        in the Privacy Policy.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>6. Security:</h2>
                                    <p>
                                        While the application employs reasonable
                                        security measures, the developer cannot
                                        guarantee the security of the
                                        information you input or generate using
                                        the application. You are responsible for
                                        taking appropriate measures to secure
                                        your data.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2> 7. Placing Orders for Products:</h2>
                                    <p>
                                        By placing an Order for Products through
                                        the Service, You warrant that You can
                                        legally enter into binding contracts.
                                        Suppose You wish to place an Order for
                                        Products available on the Service. In
                                        that case, You may be asked to supply
                                        certain information relevant to Your
                                        Order, including, without limitation,
                                        Your name, Your email, Your phone
                                        number, Your credit card number, the
                                        expiration date of Your credit card,
                                        Your billing address, and Your Shipping
                                        Information. You represent and warrant
                                        that: (i) You have the legal right to
                                        use any credit or debit card(s) or other
                                        payment method(s) in connection with any
                                        Order; and that (ii) the information You
                                        supply to us is true, correct and
                                        complete. By submitting such
                                        information, You grant us the right to
                                        provide the information to payment
                                        processing third parties to facilitate
                                        the completion of Your Order.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>8. Limitation of Liability:</h2>
                                    <p>
                                        The application is provided "as is"
                                        without warranties or guarantees. The
                                        developer is not liable for any damages
                                        or losses resulting from using the
                                        application, including but not limited
                                        to direct, indirect, incidental, or
                                        consequential damages.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2> 9. Updates and Changes:</h2>
                                    <p>
                                        The developer reserves the right to
                                        update or change the application,
                                        including these terms and conditions, at
                                        any time without prior notice. It is
                                        your responsibility to review the terms
                                        periodically for any changes.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>10. Governing Law:</h2>
                                    <p>
                                        These terms and conditions are governed
                                        by and construed in accordance with the
                                        laws of [jurisdiction] without regard to
                                        its conflict of law principles.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>11. Links to Other Websites:</h2>
                                    <p>
                                        Our Service may contain links to
                                        third-party websites or services not
                                        owned or controlled by the Company. The
                                        Company has no control over and assumes
                                        no responsibility for third-party
                                        websites or services' content, privacy
                                        policies, or practices. You further
                                        acknowledge and agree that the Company
                                        shall not be responsible or liable,
                                        directly or indirectly, for any damage
                                        or loss caused or alleged to be caused
                                        by or in connection with the use of or
                                        reliance on any such content, goods, or
                                        services available on or through any
                                        such web sites or services. We strongly
                                        advise You to read the terms and
                                        conditions and privacy policies of any
                                        third-party websites or services You
                                        visit.
                                    </p>
                                </div>
                                <div className="faq-content-item">
                                    <h2>12. Contact Information:</h2>
                                    <p>
                                        For any questions or concerns regarding
                                        these terms and conditions, please
                                        contact the company at{' '}
                                        <span>
                                            {' '}
                                            <a
                                                href="mailto:womenindigital@gmail.com."
                                                target="_blank"
                                                className="email-link-item"
                                                rel="noopener noreferrer">
                                                info.womenindigital@gmail.com
                                            </a>
                                        </span>
                                    </p>
                                    <br />
                                    <p>
                                        By using the Smart Card Generator, you
                                        acknowledge that you have read,
                                        understood, and agree to be bound by
                                        these terms and conditions.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default TermsOfServices
